import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";

export const get = (uuid = null) => async (dispatch) => {
  try {
    const res = await api.get(`/accounts/${isGuid(uuid) ? ("i/" + uuid) : ""}`);
    return isGuid(uuid) ? res.data : res.data?.items;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const search = ({
  search = "",
  page = 0,
  size = 25,
  order = "accountNumber",
  direction = "ASC",
} = {}) => async (dispatch) => {
  try {
    const term = String(search ?? "").trim();
    const searchPath = term.length ? `/${encodeURIComponent(term)}` : "";
    const url = `/accounts/p/${Number(page)}/s/${Number(size)}/o/${order}/${direction}${searchPath}`;
    const res = await api.get(url);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const save = (payload = {}) => async (dispatch) => {
  try {
    const res = await api.post(`/accounts`, payload);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

export const destroy = (uuid = null) => async (dispatch) => {
  try {
    if (!isGuid(uuid)) return;
    const res = await api.delete(`/accounts/i/${uuid}`);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};
